import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import ConsultationFormEmbed from 'components/Consultation/ConsultationFormEmbed';

interface IConsultationParams {
  activity_tag?: string;
  offer_name?: string;
  submission_URL?: string;
  country?: string;
  saved_offer_url?: string;
  currency?: string;
  finance_product?: string;
  frequency_of_payment?: string;
  net_machine_price?: string;
  deposit_in_euro?: string;
  years?: string;
  advance_payment?: string;
  number_of_following_payments?: string;
  operating_hours?: string;
  balloon_payment_residual_value_in_euro?: string;
  rate_in_percent?: string;
  loan_amount?: string;
  administration_fee_in_euro?: string;
  total_monthly?: string;
  total_per_operating_hour?: string;
  guid?: string;
  [key: string]: string | number | undefined;
}

const ConsultationFormPage = () => {
  // const { t } = useTranslation();
  const location = useLocation();

  const consultationParams: IConsultationParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const obj: IConsultationParams = {};
    params.forEach((value, key) => {
      obj[key as keyof IConsultationParams] = value;
    });
    return obj;
  }, [location.search]);

  const locale = consultationParams.country ?? 'de_DE';

  return (
    <div className='wizard-personal-information p-8'>
      <div className='my-6'>
        <ConsultationFormEmbed
          locale={locale}
          formParams={consultationParams}
        />
      </div>
    </div>
  );
};

export default ConsultationFormPage;
